<template>
    <section>

        <div>
            <b-modal :active="isModalNewEditProcessActive" aria-modal has-modal-card :destroy-on-hide="true"
                aria-role="dialog" width="100%" :can-cancel="['escape']">
                <template>
                    <ModalNewEditProcess modal-cancel="true" :update="updateProcess" :create="createProcess"
                        :proceed="proceedProcess" :processIdSelected="selectedProcess"
                        @close="isModalNewEditProcessActive = false; createProcess = false; updateProcess = false; proceedProcess = false"
                        @refresh="getProcess()" />
                </template>
            </b-modal>
        </div>

        <div class="container box mt-5">
            <div class="columns is-centered">
                <div class="column is-9">
                    <h1 class="title has-text-centered">
                        {{ fromFaculty ?
                            'Procesos del Convenio de Desempeño del Cuerpo Académico ' :
                            'Administración de Procesos de Declaración de Convenios de Desempeño' }}
                    </h1>
                </div>
            </div>

            <br>


            <div v-if="isAuthorized('PerformancePhaseCreate') && !fromFaculty" class="columns mb-0">
                <div class="column has-text-right">
                    <b-button label="Habilitar Nuevo Proceso" type="is-primary" icon-left="plus"
                        @click="isModalNewEditProcessActive = true; createProcess = true" />
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <div class="title is-5 has-text-centered">
                        Tabla de Procesos de Convenios de Desempeño
                        <hr class="dropdown-divider" aria-role="menuitem">
                    </div>
                </div>
            </div>

            <b-table :data="process" paginated per-page=10 :pagination-simple=false pagination-position="bottom"
                aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Página"
                aria-current-label="Página actual">
                <b-table-column label="Año" field="year" sortable v-slot="props">
                    {{ props.row.year }}
                </b-table-column>

                <b-table-column label="Fecha Inicio" field="start_date" sortable v-slot="props">
                    {{ props.row.start_date._isValid ? new Date(props.row.start_date).toLocaleDateString("es-CL") : ''
                    }}
                </b-table-column>

                <b-table-column label="Última Fase" field="phase_d_type.alt_name" sortable v-slot="props">
                    {{ props.row.phase_d_type.alt_name }}
                </b-table-column>

                <b-table-column label="Acciones" :width="fromFaculty ? '10%' : '40%'" v-slot="props">
                    <b-button
                        v-if="(props.row.is_active_process || props.row.is_active_last_phase) && isAuthorized('PerformancePhaseUpdateProcessDates') && !fromFaculty"
                        type="is-warning" icon-left="edit"
                        @click="selectedProcess = props.row.id; updateProcess = true; isModalNewEditProcessActive = true" />
                    <b-button
                        disabled
                        v-if="(props.row.is_active_process || props.row.is_active_last_phase) && isAuthorized('PerformancePhaseAdvanceProcess') && !fromFaculty"
                        label="Avanzar Fase" icon-left="forward"
                        @click="selectedProcess = props.row.id; proceedProcess = true; isModalNewEditProcessActive = true" />
                    <b-button v-if="isAuthorized('PerformancePhaseShowProcess')" label="Ver Proceso" type="is-primary"
                        icon-left="eye" tag="a"
                        :href="fromFaculty ? `/performance_phases/faculty/process/${props.row.year}` : `/performance_phases/process/${props.row.year}`"
                        target="_blank" />
                </b-table-column>
                <template slot="empty" slot-scope="props">
                    <div class="columns is-centered">
                        <div class="column is-6 is-centered has-text-centered">
                            <b-message type="is-warning">
                                Aún no se ha dado inicio a un Proceso de Declaración de Convenios de Desempeño.
                            </b-message>
                        </div>
                    </div>
                </template>
            </b-table>
        </div>

        <b-loading is-full-page v-model="isLoading" can-cancel />
    </section>
</template>

<script>
import axios from 'axios';
import ModalNewEditProcess from './ModalNewEditProcess.vue';
import moment from 'moment';
export default {
    name: 'ManageProcess',

    props: {
        permissions: {
            type: Array,
            required: true
        },
        fromFaculty: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    components: {
        ModalNewEditProcess
    },

    data() {
        return {
            //Auxiliares
            isLoading: false,
            isModalNewEditProcessActive: false,
            createProcess: false,
            updateProcess: false,
            proceedProcess: false,
            selectedProcess: null,

            //Datos
            process: [],
        }
    },

    created() {
        this.getProcess();
    },

    methods: {
        isAuthorized(name) {
            let permission = this.permissions.find(obj => obj.name === name)
            if (permission !== undefined) {
                return permission.value;
            }
            else {
                return false
            }
        },

        async getProcess() {
            this.isLoading = true;
            await axios
                .get('/performance_phases.json')
                .then(response => {
                    this.process = response.data;
                    this.process.forEach(element => {
                        element.start_date = moment(element.start_date, ["YYYY-MM-DD", "DD-MM-YYYY"])
                        element.end_date = moment(element.end_date, ["YYYY-MM-DD", "DD-MM-YYYY"])
                    });
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al traer la información de los Procesos. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },
    watch:{
      isModalNewEditProcessActive: function () {
        if (!this.isModalNewEditProcessActive) {
          this.getProcess()
        }
      },
    },

}
</script>